import styled from "styled-components";

const SimplebarDescription = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  text-align: center;
  flex: 1;
`

export default SimplebarDescription